<template>
    <div class="form-input form-input-radio">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field">
            <div v-for="item in options" :key="item.value" class="radio-option">
                <label class="form-input-radio-label" :class="element[field] === item.value ? 'bold' : ''">
                    <input type="radio" :value="item.value" v-model="element[field]" />
                    <span></span>
                    {{ item.title }}
                </label>
            </div>
            <div v-if="errorHas" class="form-input-error">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputRadio',
    props: {
        field: {
            type: String,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
        options: {
            type: Array,
            required: false,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
    },
    computed: {
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
    },
};
</script>
